// extracted by mini-css-extract-plugin
export default {"not_data":"NoData_not_data__4Ca10","animate-rotate":"NoData_animate-rotate__JjmC6"};